var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderGit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.736 6.377 7.626.264a.902.902 0 0 0-1.276 0l-1.27 1.27 1.61 1.61a1.071 1.071 0 0 1 1.355 1.365L9.597 6.06c1.07-.37 1.912.968 1.109 1.771-.828.828-2.195-.09-1.75-1.167L7.506 5.22v3.808c.79.391.696 1.307.284 1.718a1.073 1.073 0 1 1-1.166-1.75V5.152c-.65-.266-.769-.961-.582-1.407L4.455 2.156.265 6.348a.902.902 0 0 0 0 1.275l6.112 6.113a.902.902 0 0 0 1.275 0l6.084-6.084a.902.902 0 0 0 0-1.275z",
    fill: "#808B9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderGit);
export default __webpack_public_path__ + "static/media/folder-git.2a5ec27b63f4dcad799eb7dd2afd81fb.svg";
export { ForwardRef as ReactComponent };